module.exports = __webpack_public_path__ + "img/document.ad9b7fbc.svg";